import React from 'react'
import { TextInlineImage, TextInlineImageProps } from '../text-inline-image'
import styles from './text-inline-image-section.module.css'

export interface TextInlineImageSectionProps {
  textInlineImages: TextInlineImageProps[]
}

export const TextInlineImageSection: React.FC<TextInlineImageSectionProps> = ({
  textInlineImages,
}) => (
  <div className={styles.container}>
    {textInlineImages.map((item, index) => (
      <TextInlineImage
        key={index}
        body={item.body}
        image={item.image}
        imagePosition={item.imagePosition}
        imageShape={item.imageShape}
      />
    ))}
  </div>
)
